import React, { createRef, useState } from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import DataTable from 'react-data-table-component';


export default class SaleInvoices extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'invoice',
            selectedColumns: [true, true, false, false, false, true, false, false, true, true, true, true],
            searchColumn: 'indatimPersian',
            phrase5: '',
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 1000,
            phrase: '',
            ids: [],
            filters: {
                mtype: 1,
                type: 0,
                inp: 0,
                ins: 0
            }          
        };
        this.columnSettingsRef = createRef();
    }
    componentDidMount() {
        this.refreshData();
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside); // حذف رویداد کلیک 
    }





    enqueue(id) {
        this.sendEnqueue([id]);
    }
    sendEnqueue(ids) {
        this.httpPost("api/v1/invoice/enqueue", {
            ids: ids,
            companyId: this.state.data.global.company.id,
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("ارسال با موفقیت انجام پذیرفت گردید");
                this.refreshData();
            }
            else
                this.showErorrMessage(data.message);
        })
        .catch(err => {
            this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
        });
    }
    reference(id) {
        this.httpPost("api/v1/invoice/reference", {
            id: id,
            companyId: this.state.data.global.company.id,
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("استعلام صورتحساب دریافت شد");
                this.setState({
                    redirect: "/invoice/sale/edit/" + id
                })
            }
            else
                this.showErorrMessage(data.message);
        })
        .catch(err => {
            this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
        });
    }
    getToolBars(record) {
        var m = [];
        //m.push(<li><NavLink to={"/invoice/view/" + record.id} title="مشاهده"><em className="icon ni ni-eye"></em> <span>مشاهده</span></NavLink></li>);

        m.push(<li><NavLink to={"/invoice/sale/edit/" + record.id} title="ویرایش"><em className="icon ni ni-pen"></em> <span>مشاهده و ویرایش</span></NavLink></li>);

        if (record.status === 1 || record.status === 3 || record.sendToTax) {
            m.push(<li><a className="hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف"><em className="icon ni ni-na"></em> <span>حذف صورتحساب</span></a></li>);
        }
        if (record.status === 1 || record.status === 3) {
            m.push(<li><a className="hand" onClick={e => this.enqueue(record.id)} title="ارسال به سامانه"><em className="icon ni ni-send"></em> <span>ارسال به سامانه</span></a></li>);
        }
        if (record.status === 2) {
            m.push(<li><a className="hand" onClick={e => this.reference(record.id)} title="استعلام"><em className="icon ni ni-search"></em> <span>استعلام صورتحساب</span></a></li>);
        }
        if (record.status === 4) {
            m.push(<li><NavLink to={"/invoice/cancell/" + record.id} title="صدور ابطالی"><em className="icon ni ni-property-remove"></em> <span>صدور ابطالی</span></NavLink></li>);
            m.push(<li><NavLink to={"/invoice/modify/" + record.id} title="صدور اصلاحی"><em className="icon ni ni-property-add"></em> <span>صدور اصلاحی</span></NavLink></li>);
            m.push(<li><NavLink to={"/invoice/sale/return/" + record.id} title="صدور برگشت از فروش"><em className="icon ni ni-property-alt"></em> <span>صدور برگشت از فروش</span></NavLink></li>);
        }
        return m;
    }
    setChecked(e, id) {
        var t = [];
        this.state.Ids.forEach(i => {
            if (i != id) t.push(i);
        });
        if (e.target.checked) t.push(id);
        this.state.Ids = t;
    }
    handleCheckboxChange = (index) => {
        const newSelectedColumns = [...this.state.selectedColumns];
        newSelectedColumns[index] = !newSelectedColumns[index];
        this.setState({ selectedColumns: newSelectedColumns });
    }
    toggleColumnSettings = () => {
        this.setState(prevState => ({ showColumnSettings: !prevState.showColumnSettings }));
    }
    getFilteredRecords = () => {
        const { phrase5, searchColumn } = this.state;
        const records = this.state.data.records;

        if (!phrase5) return records;

        return records.filter(record => {
            return record[searchColumn].toString().includes(phrase5);
        });
    };

    handleClickOutside = (event) => {
        if (this.columnSettingsRef.current && !this.columnSettingsRef.current.contains(event.target)) {
            this.setState({ showColumnSettings: false }); // بستن باکس در صورت کلیک خارج 
        }
        }

    renderForm() {

        const Columns = [
            {
                name: 'ردیف',
                selector: (row, index) => this.genRowNumber(index),
                sortable: true,
                center: true
            },
            { name: 'تاریخ', selector: row => row.indatimPersian, sortable: true, center: true },
            { name: 'الگو', selector: row => row.inpString, sortable: true },
            { name: 'موضوع', selector: row => row.insString, sortable: true, center: true},
            { name: 'نوع', selector: row => row.intyString, sortable: true, center: true },
            { name: 'سریال', selector: row => row.inno, sortable: true, center: true },
            { name: 'شماره منحصربفرد مالیاتی', selector: row => row.taxId, sortable: true, center: true, width: "180px" },
            { name: 'شماره مالیاتی مرجع', selector: row => row.irtaxId,  sortable: true, center: true },
            {
                name: 'طرف حساب',
                selector: row => row.customerName,
                format: row => (
                    <span style={{ fontSize: '12px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                        {row.customerName}
                    </span>
                ),
                sortable: true,
                center: true,
                width: "160px"
            },
            { name: 'مبلغ کل', selector: row => row.tbill, format: row => row.tbill == null ? "" : row.tbill.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + ","), sortable: true, center: true},
            {
                name: 'وضعیت',
                selector: row => row.status,
                cell: row => (
                    <div className="nk-tb-col tb-col-lg text-center">
                        {row.status === 1 && <span className="tb-status text-info">{row.statusString}</span>}
                        {row.status === 2 && <span className="tb-status text-warning">{row.statusString}</span>}
                        {row.status === 3 && <span className="tb-status text-danger">{row.statusString}</span>}
                        {row.status === 4 && <span className="tb-status text-success">{row.statusString}</span>}
                    </div>
                ),
                sortable: true,
                center: true,
                width: "150px"
            },
            {
                name: 'عملیات',
                cell: row => (
                    <ul className="nk-tb-actions gx-1">
                        <li>
                            <div className="dropdown">
                                <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown">
                                    <em className="icon ni ni-more-h"></em>
                                </a>
                                <div className="dropdown-menu dropdown-menu-end">
                                    <ul className="link-list-opt no-bdr">
                                        {this.getToolBars(row)}
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                ),
                sortable: true,
                center: true,
                width: "150px"
            },
        ];
        const visibleColumns = Columns.filter((column, index) => this.state.selectedColumns[index]);







        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست صورتحسابهای فروش</h3>
                            <div className="nk-block-des text-soft">
                                <p>شما {this.money(this.state.data.recordsCount)} صورتحساب ثبت شده دارید</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a onClick={e => this.getPdfs(e)} className="btn btn-white btn-outline-light"><em className="icon ni ni-file-pdf"></em><span>خروجی PDF</span></a>
                                        </li>
                                        <li>
                                            <a onClick={e => this.getExcels(e)} className="btn btn-white btn-outline-light"><em className="icon ni ni-file-xls"></em><span>خروجی Excel</span></a>
                                        </li>
                                        <li>
                                            <NavLink to="/invoice/sale/upload/" className="btn btn-white btn-outline-light"><em className="icon ni ni-download-cloud"></em><span>ورود اکسل اطلاعات</span></NavLink>
                                        </li>
                                        <li className="nk-block-tools-opt">
                                            <div className="drodown">
                                                <a href="#" className="dropdown-toggle btn btn-icon btn-primary" data-bs-toggle="dropdown" aria-expanded="true"><em className="icon ni ni-plus"></em></a>
                                                <div className="dropdown-menu dropdown-menu-end" data-popper-placement="bottom-end">
                                                    <ul className="link-list-opt no-bdr">
                                                        <li><NavLink to="/invoice/sale/new1/"><span>فروش</span></NavLink></li>
                                                        <li><NavLink to="/invoice/sale/new2/"><span>فروش ارزی</span></NavLink></li>
                                                        <li><NavLink to="/invoice/sale/new3/"><span>طلا و جواهر و پلاتین</span></NavLink></li>
                                                        <li><NavLink to="/invoice/sale/new4/"><span>پیمانکاری</span></NavLink></li>
                                                        <li><NavLink to="/invoice/sale/new5/"><span>قبوض خدماتی</span></NavLink></li>
                                                        <li><NavLink to="/invoice/sale/new6/"><span>بلیت هواپیما</span></NavLink></li>
                                                        <li><NavLink to="/invoice/sale/new7/"><span>صادرات</span></NavLink></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        {this.state.data.recordsCount <= 0 ?
                            <div className="card-inner-group">
                                <div className="example-alert">
                                    <div className="alert alert-pro alert-warning">
                                        <div className="alert-text">
                                            <h6>توجه</h6>
                                            <p>در حال حاضر هیچ صورتحساب فروشی برای شرکت شما ثبت نشده است</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="card-inner-group">
                                <div className="custom-scroll data-table-container-wrapper" >                             
                                <DataTable
                                    columns={visibleColumns}
                                    data={this.getFilteredRecords()}
                                    
                                    noDataComponent={<div className="mt-3">رکوردی برای نمایش وجودی ندارد</div>}
                                    direction="rtl"                                   
                                    subHeader
                                    className={ this.state.data.recordsCount < 6 ? 'custom-scroll data-table-container-wrapper' : 'custom-scroll' }
                                    subHeaderComponent={
                                        <div className="row w-100" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div className="row col-md-6">
                                                <div className="col-md-4">
                                                    <div className="form-wrap me-2">
                                                        <input
                                                            defaultValue={this.state.phrase5}
                                                            onChange={e => this.setState({ phrase5: e.target.value })}
                                                            type="text"
                                                            placeholder="جست و جو بر اساس"
                                                            className="form-control"
                                                            style={{ width: '150px', height: '40px', textAlign: 'center' }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-wrap">
                                                        <select
                                                            onChange={e => this.setState({ searchColumn: e.target.value })}
                                                            className="form-select form-select-lg "
                                                            style={{ width: '150px', height: '40px', textAlign: 'center', fontSize: '0.8rem' }}
                                                        >
                                                            <option value="indatimPersian">تاریخ</option>
                                                            <option value="inpString">الگو</option>
                                                            <option value="insString">موضوع </option>
                                                            <option value="intyString">نوع</option>
                                                            <option value="inno">سریال</option>
                                                            <option value="taxId">شماره منحصربفرد مالیاتی</option>
                                                            <option value="irtaxId">شماره مالیاتی مرجع</option>
                                                            <option value="customerName">طرف حساب</option>
                                                            <option value="tbill">مبلغ کل </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 d-flex justify-content-end position-relative">

                                                <button
                                                    onClick={this.toggleColumnSettings}
                                                    className={`m-1 btn btn-secondary bi bi-layout-three-columns ${this.state.showColumnSettings ? 'button-collapse' : ''}`}
                                                    style={{
                                                        height: '40px',                                                   
                                                        fontSize:'1.1rem'
                                                    }}
                                                >
                                                </button>

                                                {this.state.showColumnSettings && (
                                                    <div
                                                        ref={this.columnSettingsRef}
                                                        className="position-absolute bg-white p-3 border custom-scroll"
                                                        style={{
                                                            top: '40px',
                                                            right:'250px',                             
                                                            width: '250px',
                                                            maxHeight: '200px',
                                                            overflowY: 'auto',
                                                            zIndex: '1000',
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                                                        }} >
                                                        {Columns.map((column, index) => (
                                                            <label key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        checked={this.state.selectedColumns[index]}
                                                                        onChange={() => this.handleCheckboxChange(index)}
                                                                        style={{ marginLeft: '10px' }}
                                                                /> 
                                                                {column.name}
                                                            </label>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    }
                                    persistTableHead
                                />  
                                    </div>   
                                </div>                  
                        }
                    </div>
                </div>
            </div>
        </div>
    }
    render() {

        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmptyAnnualsOrCompanies(this.state.data.global) ? this.renderNoCompanyOrAnnualRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}